import styles from './styles.module.css';

export const valueToDisplay = (value) => {
  if (value === null || value === undefined || value === '') return null;
  if (Array.isArray(value)) return value.length ? value : null;
  if (typeof value === 'object') return JSON.stringify(value, null, 2);
  return String(value);
};

export const ConfidenceDot = ({ confidence }) => {
  const level = String(confidence || '').toLowerCase();
  if (level === 'high') return <span className={`${styles.dot} ${styles.dotHigh}`} title="High confidence" />;
  if (level === 'medium') return <span className={`${styles.dot} ${styles.dotMedium}`} title="Medium confidence" />;
  if (level === 'low') return <span className={`${styles.dot} ${styles.dotLow}`} title="Low confidence" />;
  return null;
};

export const FieldCard = ({ field }) => {
  const raw = valueToDisplay(field.value);
  const isArray = Array.isArray(raw);
  const evidence = Array.isArray(field.evidence) && field.evidence.length ? field.evidence : null;

  return (
    <article className={`${styles.card} ${!raw ? styles.cardEmpty : ''}`}>
      <header className={styles.cardHeader}>
        <p className={styles.cardLabel}>{field.label}</p>
        <ConfidenceDot confidence={field.confidence} />
      </header>
      {raw ? (
        isArray ? (
          <ul className={styles.chipList}>
            {raw.map((item, i) => <li key={i} className={styles.chip}>{item}</li>)}
          </ul>
        ) : (
          <p className={styles.cardValue}>{raw}</p>
        )
      ) : (
        <p className={styles.cardValueEmpty}>—</p>
      )}
      {evidence && (
        <ul className={styles.evidenceList}>
          {evidence.map((e, i) => <li key={i} className={styles.evidenceItem}>{e}</li>)}
        </ul>
      )}
    </article>
  );
};

export const FieldsGrid = ({ fields = [] }) => {
  if (!fields.length) return null;
  return (
    <div className={styles.grid}>
      {fields.map((f) => <FieldCard key={f.key || f.label} field={f} />)}
    </div>
  );
};

export const SummaryCard = ({ summary, confidence }) => {
  if (!summary) return null;
  return (
    <section className={styles.summaryCard}>
      <p className={styles.sectionLabel}>Summary</p>
      <p className={styles.summaryText}>{summary}</p>
      {confidence ? (
        <div className={styles.summaryFooter}>
          <span className={styles.metaLabel}>Profile confidence</span>
          <span className={`${styles.badge} ${styles[`badge${confidence}`]}`}>{confidence}</span>
        </div>
      ) : null}
    </section>
  );
};

export const AssessmentCard = ({ assessment }) => {
  if (!assessment) return null;
  return (
    <section className={styles.assessmentCard}>
      <p className={styles.sectionLabel}>Assessment</p>
      <p className={styles.assessmentText}>{assessment}</p>
    </section>
  );
};

export const DiagnosticsFooter = ({ missingFlags = [] }) => {
  if (!missingFlags.length) return null;
  return (
    <section className={styles.missingSection}>
      <p className={styles.sectionLabel}>Missing data</p>
      <ul className={styles.chipList}>
        {missingFlags.map((f) => (
          <li key={f} className={`${styles.chip} ${styles.chipMuted}`}>{f.replace(/_/g, ' ')}</li>
        ))}
      </ul>
    </section>
  );
};

export const EmptyState = () => (
  <div className={styles.emptyState}>
    <p className={styles.emptyTitle}>No report generated yet</p>
    <p className={styles.emptyBody}>This section will populate once the store profile report for this tab is generated.</p>
  </div>
);

export const usePayload = (report) => {
  if (!report) return null;
  return report.data || report;
};
